import { render, staticRenderFns } from "./ProfilEdit.vue?vue&type=template&id=85ab81aa&scoped=true"
import script from "./ProfilEdit.vue?vue&type=script&lang=js"
export * from "./ProfilEdit.vue?vue&type=script&lang=js"
import style0 from "./ProfilEdit.vue?vue&type=style&index=0&id=85ab81aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ab81aa",
  null
  
)

export default component.exports